import { render, staticRenderFns } from "./MaterialListTable.vue?vue&type=template&id=18522922&scoped=true"
import script from "./MaterialListTable.vue?vue&type=script&lang=js"
export * from "./MaterialListTable.vue?vue&type=script&lang=js"
import style0 from "./MaterialListTable.vue?vue&type=style&index=0&id=18522922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18522922",
  null
  
)

export default component.exports